export const InfoTooltipStyles = {
    wrapper: "relative inline-block mt-4 sm:mt-5",
    button: "flex items-center text-gray-500 hover:text-gray-700 text-sm focus:outline-none",
    icon: "w-4 h-4 mr-1",
    tooltipContainer: "absolute left-1/2 bottom-full mb-3 -translate-x-1/2 z-10 bg-[#5A26C5] text-white text-sm rounded-xl shadow-lg p-3 w-[290px] md:w-[380px] pr-[60px]",
    tooltipShadow: "drop-shadow(0px 2px 6px rgba(0,0,0,0.2))",
    tooltipTriangleWrapper: "absolute bottom-0 left-1/2 translate-x-[-50%] translate-y-full",
    tooltipTriangle: "w-4 h-4 text-[#5A26C5]",
    tooltipText: "text-sm leading-snug text-left",
};